import React, { Component } from "react";
import { Provider } from "react-redux";
import { ConfigProvider } from "antd";
import createStore from "./redux/store";
import { history } from "./redux/enhancers/middlewares/router";
import Layout from "./containers/Layout/Layout";
import "./styles/style.scss";
import config from "./styles/ConfigAntd";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Router } from "react-router-dom/cjs/react-router-dom.min";
import { ErrorBoundary } from "react-error-boundary";
import { I18nextProvider } from "react-i18next";
import ConfigTranslation from "./translations";
import locale from "antd/locale/fr_FR";
import { HelmetProvider } from "react-helmet-async";
import ErrorPage from "./containers/ErrorPages/ErrorPage";
import dayjs from "dayjs";
import "dayjs/locale/fr";
import packageJson from "../package.json";

dayjs.locale("fr");
class App extends Component {
    render() {
        console.log(`Front EQDOM version ${packageJson.version}`);
        return (
            <Provider store={createStore()}>
                <ErrorBoundary fallback={<ErrorPage />}>
                    <HelmetProvider>
                        <Router history={history}>
                            <I18nextProvider i18n={ConfigTranslation}>
                                <ConfigProvider locale={locale} theme={config}>
                                    <Layout />
                                </ConfigProvider>
                                <ToastContainer style={{ marginTop: "5rem" }} />
                            </I18nextProvider>
                        </Router>
                    </HelmetProvider>
                </ErrorBoundary>
            </Provider>
        );
    }
}

export default App;
